<template>
  <div class="pack-section" v-if="packs && packs.length > 0">
    <h2 class="title pack-section__title">
      CHOOSE <span class="orange">PACK</span>:
    </h2>
    <div v-if="loading" class="pack-section__loading">Loading packs...</div>
    <div v-else-if="error" class="pack-section__error">{{ error }}</div>
    <div v-else class="pack-section__grid">
      <div v-for="pack in packs" :key="pack.id" class="pack-section__item">
        <PackCard
          :pack="pack"
          @addToCart="addPackToCart"
          :currency="currency || getCurrency()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PackCard from "./PackCard.vue";
import usePacks from "@/composables/usePacks";

export default {
  name: "PackSection",
  components: {
    PackCard,
  },
  props: {
    currency: {
      type: String,
      default: ""
    },
    currencyCode: String
  },
  data() {
    return {
      packsModule: usePacks(),
      packs: [],
      loading: true,
      error: null,
    };
  },
  inject: ["addedItemId", "getCurrency"],
  watch: {
    currencyCode: function() {
      this.fetchPacks();
    }
  },
  mounted() {
    this.fetchPacks();
  },
  methods: {
    fetchPacks() {
      this.loading = true;
      this.error = null;

      this.packsModule
        .fetchPacks()
        .then((data) => {
          if (data) {
            this.packs = data;
          } else {
            this.packs = this.packsModule.packs.value;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error fetching packs:", error);
          this.error = error.message || "Failed to load packs";
          this.loading = false;
        });
    },
    addPackToCart(pack, id, quantity = 1) {
      this.$emit(
        "addToCart",
        {
          ...pack,
          type: "pack",
        },
        id,
        quantity,
        "pack"
      );
    },
  },
};
</script>

<style scoped>
.pack-section {
  padding: 200px 16px 0px;
  width: 100%;
}

.pack-section__title {
  font-family: "Outfit", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 52px;
  line-height: 66px;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  margin-bottom: 60px;
}

.orange {
  color: #f75d10;
}

.pack-section__loading,
.pack-section__error {
  text-align: center;
  font-size: 18px;
  padding: 40px 0;
  color: #ffffff;
}

.pack-section__error {
  color: #da1e01;
}

.pack-section__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  max-width: 1300px;
  margin: 0 auto;
}

@media (max-width: 1200px) {
  .pack-section__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767px) {
  .pack-section {
    padding: 60px 16px 0px;
  }

  .pack-section__title {
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 40px;
  }

  .pack-section__grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
</style>
